export default __webpack_public_path__ + "static/media/sbslogo.0d2ae71d.png";